'use strict';

DoohApps
.directive('capsLock', [function () {
    return {
        restrict: 'A',
        scope: {
            capsLock: '='
        },
        link: function (scope, element, attrs) {
            $(window).capslockstate();
            scope.capsLock = $(window).capslockstate('state') == true;

            $(window).on('capsChanged', function (event) {
                scope.capsLock = $(window).capslockstate('state') == true;
                scope.$apply();
            });
            element.on('keypress', function (event) {
                scope.capsLock = $(window).capslockstate('state') == true;
            })
            element.on('blur', function (event) {
                scope.capsLock = false;
            });

        }
    }
}]);